import { Row } from "@/components/customComponents";
import type { ICreatorSummary } from "@/pages/CreatorAnalytics/types";
import { buildSummaryCards } from "@/pages/CreatorAnalytics/utils";

import SummaryCard from "./SummaryCard";

interface ISummaryCardsProps {
  summary: ICreatorSummary;
  dateFrom: string;
}

const SummaryCards = ({ summary, dateFrom }: ISummaryCardsProps) => {
  const isFavoritesAvailable = dateFrom >= summary.favoritesAvailableFrom;
  const cards = buildSummaryCards(summary, isFavoritesAvailable);

  return (
    <Row className="flex-wrap gap-3">
      {cards.map((card) => (
        <SummaryCard key={card.label} {...card} />
      ))}
    </Row>
  );
};

export default SummaryCards;
